
const imgRoxana = 'https://kswd-hfls-site.s3-us-west-1.amazonaws.com/images/aboutUs/rox2.png';
const imgMelanie = 'https://kswd-hfls-site.s3-us-west-1.amazonaws.com/images/aboutUs/melanie.png';
const imgRobert = 'https://kswd-hfls-site.s3-us-west-1.amazonaws.com/images/aboutUs/robert.png';

const people = [
  {
    name: 'Roxana Núñez Trabucco',
    title: 'Author',
    image: imgRoxana,
    text: [
      'Roxana is a Peruvian author and teacher that holds a Masters Degree in Applied Linguistics to Teach Spanish as a Foreign Language, from the University of Jaén (Spain). Throughout her more than 16 years of experience as an elementary school Spanish teacher in California, and before beginning her career as an author, Roxana developed material considering her students suggestions and the specific conditions where she had to teach Spanish, as an after school activity.',
      'The results are these textbooks series Have Fun Learning Spanish that have been tested several times and try to expose children to the Spanish language at a young age, emphasizing the importance of movement and playing while learning, and at the same time introducing children to literacy and reading as a base to acquire a solid foundation in the Spanish language.',
      'Roxana’s works is in process as she is still developing new textbooks, songs to reinforce what has been learned, bilingual stories and online material for teachers and students.',
      'In her free time Roxana enjoys traveling, reading, and translating children’s and young adult’s books into Spanish.',
    ],
  },
  {
    name: 'Melanie Fay',
    title: 'Illustrator',
    image: imgMelanie,
    text: [
      'Melanie Fay is a freelance illustrator and art teacher living in upstate New York. She studied at The School of the Art Institute of Chicago and holds a BFA from The Cooper Union School of Art. She loves animals and art projects and really anything that is creative and fun.',
    ],
    link: 'http://www.melaniefay.com/',
  },
  {
    name: 'Robert Alminana',
    title: 'Editor',
    image: imgRobert,
    text: [
      'Robert Alminana is an educator living in San Francisco. He grew up in a multi-lingual, multi-national family and has lived in 9 different countries. He speaks five languages, is passionate about migration stories and loves to travel the world.',
    ],
  },
];

export default people;



// WEBPACK FOOTER //
// ./src/components/AboutUs/people.data.js